module.exports = __webpack_public_path__ + "static/media/69.8f53dd2b.png";